import { Product, ProductListConfig } from "../types/types";
import { componentMap } from "../product-card-components/componentMap";
import styles from "./ProductCardSlot.module.scss";

type Props = {
  slotName: string;
  config: ProductListConfig;
  className?: string;
  product: Product;
  index: number;
  bordered?: boolean;
  id?: string;
};

export const Slot = ({
  slotName,
  config,
  className,
  product,
  index: cardIndex,
  bordered = false,
  id,
}: Props) => {
  const components = config["product-card-slots"][slotName];

  if (!components || components.length < 1) {
    return null;
  }

  return (
    <div
      id={id}
      className={className}
      data-product-card-slot={slotName}
      data-testid={`product-card-slot-${slotName}`}
    >
      {components?.map((componentConfig, index) => {
        const Component = componentMap[componentConfig.name];
        const componentKey = `${componentConfig.name}-${index}`;

        const Element = Component ? (
          <Component
            key={bordered ? undefined : componentKey}
            configProps={componentConfig.props}
            product={product}
            index={cardIndex}
          />
        ) : null;

        return Element ? (
          bordered ? (
            <div className={styles.wrapper} key={componentKey}>
              {Element}
            </div>
          ) : (
            Element
          )
        ) : null;
      })}
    </div>
  );
};
